<template>
  <div class="statistics-container">
    <div class="page-header">
      <h2>统计管理</h2>
      <p>查看和管理系统统计数据</p>
    </div>
    
    <div class="statistics-content">
      <el-card class="statistics-overview">
        <div slot="header" class="clearfix">
          <span>数据概览</span>
        </div>
        <div class="card-content">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="stat-item">
                <div class="stat-value">{{ totalUsers }}</div>
                <div class="stat-label">总用户数</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-item">
                <div class="stat-value">{{ totalDevices }}</div>
                <div class="stat-label">设备总数</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-item">
                <div class="stat-value">{{ totalDeliveries }}</div>
                <div class="stat-label">投递总量</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-item">
                <div class="stat-value">{{ totalRevenue }}</div>
                <div class="stat-label">总收入</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
      
      <div class="charts-section">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card>
              <div slot="header" class="clearfix">
                <span>用户增长趋势</span>
              </div>
              <div class="chart-container">
                <!-- 图表占位 -->
                <div class="chart-placeholder">用户增长趋势图表</div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card>
              <div slot="header" class="clearfix">
                <span>设备使用分布</span>
              </div>
              <div class="chart-container">
                <!-- 图表占位 -->
                <div class="chart-placeholder">设备使用分布图表</div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      
      <div class="statistics-details" style="margin-top: 20px;">
        <el-card>
          <div slot="header" class="clearfix">
            <span>详细统计数据</span>
          </div>
          <el-table :data="statisticsTableData" style="width: 100%">
            <el-table-column prop="name" label="统计项" width="180" />
            <el-table-column prop="value" label="数值" width="120" />
            <el-table-column prop="unit" label="单位" width="80" />
            <el-table-column prop="growth" label="环比增长" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.growth > 0 ? 'success' : 'danger'" size="small">
                  {{ scope.row.growth > 0 ? '+' : '' }}{{ scope.row.growth }}%
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="description" label="说明" />
          </el-table>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Statistics',
  data() {
    return {
      totalUsers: 245,
      totalDevices: 128,
      totalDeliveries: 3578,
      totalRevenue: '¥128,500',
      statisticsTableData: [
        { name: '活跃用户', value: 189, unit: '人', growth: 5.2, description: '近30天活跃用户数' },
        { name: '新增设备', value: 24, unit: '台', growth: 12.8, description: '本月新增设备数量' },
        { name: '完成投递', value: 1256, unit: '次', growth: 8.3, description: '本月完成投递次数' },
        { name: '设备故障率', value: 1.2, unit: '%', growth: -0.3, description: '设备故障比例' },
        { name: '平均处理时间', value: 15, unit: '分钟', growth: -2.1, description: '任务平均处理时间' }
      ]
    }
  },
  methods: {
    // 刷新统计数据
    refreshStatistics() {
      this.$message.success('统计数据已刷新')
    }
  },
  mounted() {
    // 可以在这里初始化图表等
  }
}
</script>

<style scoped>
.statistics-container {
  padding: 20px;
}

.page-header h2 {
  color: #303133;
  font-size: 24px;
  margin-bottom: 10px;
}

.page-header p {
  color: #606266;
  font-size: 14px;
  margin-bottom: 30px;
}

.statistics-overview {
  margin-bottom: 20px;
}

.stat-item {
  text-align: center;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 5px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #409eff;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  color: #606266;
}

.charts-section {
  margin-bottom: 20px;
}

.chart-container {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-placeholder {
  color: #909399;
  font-size: 16px;
}
</style>